import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { RappiderTagInputComponent } from './tag-input.component';
import { RappiderButtonModule } from '../button/button.module';


@NgModule({
  declarations: [
    RappiderTagInputComponent
  ],
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    RappiderButtonModule
  ],
  exports: [
    RappiderTagInputComponent
  ]
})
export class RappiderTagInputModule { }
